import { createSlice } from '@reduxjs/toolkit';
import {
  fetchAirBrakeParams,
  fetchFloorPvcParams,
  fetchFurnishingQciParams,
  fetchFurnishingTestingBiotoiletParams,
  fetchFurnishingTestingFireParams,
  fetchLavatoryParams,
  fetchMouldingDoorParams,
  fetchPanellingParams,
  fetchPartitionParams,
  fetchPlumbingParams,
  fetchSeatAndBerthParams,
  fetchWindowCellingParams,
  listFloorPvc,
  fetchviewFloorPvc,
  listPartition,
  fetchviewPartition,
  deleteWindowCeilingData,
  fetchWindowCeilingList,
  storeWindowCeilingData,
  viewWindowCeilingData,
  saveMouldingDoor,
  fetchMouldingDoorList,
  fetchMouldingDoorById,
  savePlumbing,
  fetchPlumbingList,
  fetchPlumbingById,
  saveAirBrake,
  fetchAirBrakeList,
  fetchAirBrakeById,
  viewSeatBerthData,
  fetchSeatBerthList,
  storeSeatBerthData,
  viewLavatoryData,
  fetchLavatoryList,
  storeLavatoryData,
  fetchBufferCbcParams,
  fetchTestingLeakageParams,
  fetchTestingAirBrakeParams,
  fetchTestingFibaParams,
  fetchviewPanneling,
  listPanneling,
  fetchShellNo,
  updateFurnishingStatus,
  fetchFurnishingFlowHistory,
  airBrakeFlowHistory,
  fetchPlumbingFlowHistory,
  fetchMouldingDoorFlowHistory,
  fetchFurnishingHistoryFlow,
  fetchTestingBufferCbcObsparams,
  listTestingFire,
  fetchviewFire,
  listBiotoilet,
  fetchViewBiotoilet,
  listLeakage,
  fetchviewLeakage,
  fetchFurnishingQciCompletedStages,
  deleteFurnishingQci,
  fetchFurnishingQciFlowHistory,
  furnishingQciInspectionAction,
  fetchFurnishingQciStageById,
  viewFurnishingQciAssembly,
  fetchFurnishingQciList,
  saveFurnishingQciData,
  fetchFireHistoryFlow,
  fetchLeakageHistoryFlow,
  fetchBiotoiletHistoryFlow,
  checkExistRecord,
  fetchPvcTypeExists,
  viewFloorPvcAssembly,
  fetchFloorPvcFlowHistory,
  viewWindowCeilingStage,
  fetchWindowCeilingNonAcFlowHistory,
  fetchRoomTypes,
  getIcFormParams,
  fetchFurnishingQciLastStageData,
  fetchViewFloorBoard,
  getDcouplingParams,
  listFloorBoard,
  fetchFloorBoardParams,
  fetchSafFloorPvcParams,
  fetchViewSafFloorPvc,
  fetchPlugDoorParams,
  fetchGangwayParams,
  fetchGlasswoolParams,
  fetchSafWindowParams,
  fetchSafPartitionParams,
  addDCoupling,
  fetchListDcouplingData,
  fetchDCouplingById,
  fetchDCouplingFlowHistory,
  getAcDuctParams,
  getViewGlassWool,
  listGlassWool,
  fetchListGangwayData,
  addGangway,
  fetchGangwayById,
  fetchGangwayFlowHistory,
  addAcDuctData,
  fetchFloorBoardHistory,
  listSafVbFloorBoard,
  fetchVbFloorPvcHistory,
  fetchLuggageRackParams,
  fetchSeatInspectionVBParams,
  fetchGlassWoolHistory,
  fetchVbAirbrakeParams,
  getViewAcDuct,
  listAcDuct,
  fetchAcDuctHistory,
  addWindow,
  fetchListWindowData,
  fetchWindowById,
  fetchWindowFlowHistory,
  fetchPanellingVBParams,
  fetchLavatoryVBParams,
  plugDoorListing,
  fetchLuggageRacklist,
  fetchVbPanelFlowHistory,
  fetchVbPanelById,
  fetchListVbPanelData,
  addVbPanelling,
  seatInspectionActionVB,
  fetchSeatInspectionVBFlowHistory,
  fetchSeatInspectionVBById,
  fetchListSeatInspectionVB,
  addSeatInspectionVB,
  partitionInspectionActionVB,
  fetchPartitionFlowHistoryVB,
  fetchPartitionByIdVB,
  fetchListPartitionDataVB,
  addPartitionVB,
  fetchVbLavatoryFlowHistory,
  fetchVbLavatoryById,
  fetchListVbLavatoryData,
  addVbLavatory,
  airBrakeTestActionVB,
  fetchAirBrakeTestFlowHistoryVB,
  fetchAirBrakeTestByIdVB,
  fetchListAirBrakeTestVB,
  addAirBrakeTestVB,
  fetchTractionParams,
  checkRecordExist,
  fetchBrakeEquipmentSupplier,
  fetchInstalledBy,
  fetchPartitionFlowHistoryLHB,
} from './furnishingThunk';

const initialState = {
  floorPvcParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  partitionParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  panellingParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  seatBerthParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  lavatoryParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  plumbingParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  airBrakeParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  testingFiba: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  windowCellingParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  mouldingDoorParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  furnishingQciParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  fireParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  windowCeiling: {
    loading: false,
    success: false,
    error: null,
    params: [],
    list: {
      data: [],
      pagination: {
        current_page: 1,
        per_page: 10,
        total: 0,
        total_pages: 0,
      },
    },
  },

  biotoiletParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  testingbufferCbcObs: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  testingLeakageParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  getlistFloorPvc: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  getViewFloorPvc: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  getlistPartition: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  getViewPartition: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  mouldingDoorSave: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },

  mouldingDoorList: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: null,
  },
  mouldingDoorDetail: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  plumbingSave: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  plumbingList: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: null,
  },
  plumbingDetail: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  airBrakeList: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: null,
  },
  airBrakeSave: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  airBrakeDetail: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  getlistPanneling: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  getViewPanneling: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  getShellNo: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  getSuppliers: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  getInstalledBy: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  fetchPartitionFlowHistoryLHB: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  seatBerthList: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: {
      current_page: 1,
      per_page: 10,
      total: 0,
      total_pages: 0,
    },
  },
  seatBerthView: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  seatBerthSave: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },

  lavatoryList: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: {
      current_page: 1,
      per_page: 10,
      total: 0,
      total_pages: 0,
    },
  },
  lavatoryView: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  lavatorySave: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  testingairbrakeparams: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  mouldingDoorFlowHistory: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  plumbingFlowHistory: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  airBrakeFlowHistory: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  furnishingStatus: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  furnishingHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
    application: null,
  },
  flowHistory: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  getListTestingFire: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  getViewFire: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  getListBiotoilet: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  getViewBiotoilet: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  getListLeakage: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  getViewLeakage: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  furnishingQciDataSave: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  furnishingQciList: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: null,
  },
  viewFurnishingQciAssembly: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  furnishingQciStageDetail: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  furnishingQciAction: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  furnishingQciFlowHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  furnishingQciDelete: {
    loading: false,
    success: false,
    error: null,
  },

  furnishingQciCompletedStages: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  getFireflowHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  getLeakageflowHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  existingRecordDetails: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  getBoitoiletflowHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  getPvcTypeExists: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  getviewFloorPvcStage: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  getviewFloorPvcFlowHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  getViewWindowCeilingStage: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  getWindowCeilingNonAcFlowHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  roomTypes: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  icFormParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  furnishingQciLastStageData: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  getViewFloorBoard: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  dCouplingParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  getlistFloorBoard: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: {
      current_page: 1,
      per_page: 10,
      total: 0,
      total_pages: 1,
    },
  },

  floorBoardParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  floorSafPvcParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  getViewSafFloorPvc: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  // Plug Door Data
  plugDoorData: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  gangwayParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  dcoupligStoreData: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  DCouplingListData: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  dCouplingDetail: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: [],
  },
  dCouplingFlowHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  glasswoolParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  acDuctParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  safWindowParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  safPartitionParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  //Luggage Rack Data
  luggageRackData: {
    loading: false,
    success: false,
    data: [],
    error: null,
  },

  acDuctStoreData: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  floorBoardHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  plugDoorListing: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  getlistVbFloorPvc: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: {
      current_page: 1,
      per_page: 10,
      total: 0,
      total_pages: 1,
    },
  },

  VbfloorPvcHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  seatParams: {
    loading: false,
    success: false,
    data: [],
    error: null,
  },

  GangwayListData: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: [],
  },
  gangwayStoreData: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  gangwayDetail: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  gangwayFlowHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  fetchViewGlassWool: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  fetchListGlassWool: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: {
      current_page: 1,
      per_page: 10,
      total: 0,
      total_pages: 1,
    },
  },

  GlassWoolHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  WindowListData: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: [],
  },
  WindowStoreData: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  windowDetail: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  windowFlowHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  //ac duct

  fetchViewAcDuct: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  fetchListAcDuct: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: {
      current_page: 1,
      per_page: 10,
      total: 0,
      total_pages: 1,
    },
  },

  acDuctHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  vbAirbrakeParams: {
    loading: false,
    success: false,
    data: [],
    error: null,
  },

  vbPanellingParams: {
    loading: false,
    success: false,
    data: [],
    error: null,
  },
  vbLavatoryParams: {
    loading: false,
    success: false,
    data: [],
    error: null,
  },
  VbPanleListData: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: [],
  },
  VbPanelStoreData: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  VbPanelDetail: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  VbPanelFlowHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  VbLavatoryListData: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: [],
  },
  VbLavatoryStoreData: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  VbLavatoryDetail: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  VbLavatoryFlowHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  PartitionVBStoreData: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  PartitionVBListData: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: [],
  },
  partitionVBDetail: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  partitionVBFlowHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  SeatInspectionVBListData: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: [],
  },
  SeatInspectionVBStoreData: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  seatInspectionVBDetail: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  seatInspectionVBFlowHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  luggageRackList: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  AirBrakeTestVBListData: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: [],
  },
  AirBrakeTestVBStoreData: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  airBrakeTestVBDetail: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  airBrakeTestVBFlowHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  // Add tractionParams state
  tractionParams: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  checkRecord: {
    loading: false,
    data: null,
    error: null,
    exists: false,
  },
};

const furnishingSlice = createSlice({
  name: 'furnishing',
  initialState,
  reducers: {
    clearMouldingDoorParams: (state) => {
      state.mouldingDoorParams.data = [];
      state.mouldingDoorParams.success = false;
      state.mouldingDoorParams.error = null;
    },
    clearPlumbingParams: (state) => {
      state.plumbingParams.data = [];
      state.plumbingParams.success = false;
      state.plumbingParams.error = null;
    },
    clearAirBrakeParams: (state) => {
      state.airBrakeParams.data = [];
      state.airBrakeParams.success = false;
      state.airBrakeParams.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFloorPvcParams.pending, (state) => {
        state.floorPvcParams.loading = true;
        state.floorPvcParams.error = null;
      })
      .addCase(fetchFloorPvcParams.fulfilled, (state, action) => {
        state.floorPvcParams.loading = false;
        state.floorPvcParams.data = action.payload;
      })
      .addCase(fetchFloorPvcParams.rejected, (state, action) => {
        state.floorPvcParams.loading = false;
        state.floorPvcParams.error = action.payload || 'Something wents wrong';
      })

      .addCase(fetchPartitionParams.pending, (state) => {
        state.partitionParams.loading = true;
        state.partitionParams.error = null;
      })
      .addCase(fetchPartitionParams.fulfilled, (state, action) => {
        state.partitionParams.loading = false;
        state.partitionParams.data = action.payload;
      })
      .addCase(fetchPartitionParams.rejected, (state, action) => {
        state.partitionParams.loading = false;
        state.partitionParams.error = action.payload || 'Something wents wrong';
      })

      .addCase(fetchPanellingParams.pending, (state) => {
        state.panellingParams.loading = true;
        state.panellingParams.error = null;
      })
      .addCase(fetchPanellingParams.fulfilled, (state, action) => {
        state.panellingParams.loading = false;
        state.panellingParams.data = action.payload;
      })
      .addCase(fetchPanellingParams.rejected, (state, action) => {
        state.panellingParams.loading = false;
        state.panellingParams.error = action.payload || 'Something wents wrong';
      })

      .addCase(fetchSeatAndBerthParams.pending, (state) => {
        state.seatBerthParams.loading = true;
        state.seatBerthParams.error = null;
      })
      .addCase(fetchSeatAndBerthParams.fulfilled, (state, action) => {
        state.seatBerthParams.loading = false;
        state.seatBerthParams.data = action.payload;
      })
      .addCase(fetchSeatAndBerthParams.rejected, (state, action) => {
        state.seatBerthParams.loading = false;
        state.seatBerthParams.error = action.payload || 'Something wents wrong';
      })

      .addCase(fetchLavatoryParams.pending, (state) => {
        state.lavatoryParams.loading = true;
        state.lavatoryParams.error = null;
      })
      .addCase(fetchLavatoryParams.fulfilled, (state, action) => {
        state.lavatoryParams.loading = false;
        state.lavatoryParams.data = action.payload;
      })
      .addCase(fetchLavatoryParams.rejected, (state, action) => {
        state.lavatoryParams.loading = false;
        state.lavatoryParams.error = action.payload || 'Something wents wrong';
      })

      .addCase(fetchPlumbingParams.pending, (state) => {
        state.plumbingParams.loading = true;
        state.plumbingParams.error = null;
      })
      .addCase(fetchPlumbingParams.fulfilled, (state, action) => {
        state.plumbingParams.loading = false;
        state.plumbingParams.data = action.payload;
      })
      .addCase(fetchPlumbingParams.rejected, (state, action) => {
        state.plumbingParams.loading = false;
        state.plumbingParams.error = action.payload || 'Something wents wrong';
      })

      .addCase(fetchAirBrakeParams.pending, (state) => {
        state.airBrakeParams.loading = true;
        state.airBrakeParams.error = null;
      })
      .addCase(fetchAirBrakeParams.fulfilled, (state, action) => {
        state.airBrakeParams.loading = false;
        state.airBrakeParams.data = action.payload;
      })
      .addCase(fetchAirBrakeParams.rejected, (state, action) => {
        state.airBrakeParams.loading = false;
        state.airBrakeParams.error = action.payload || 'Something wents wrong';
      })

      .addCase(fetchWindowCellingParams.pending, (state) => {
        state.windowCellingParams.loading = true;
        state.windowCellingParams.error = null;
      })
      .addCase(fetchWindowCellingParams.fulfilled, (state, action) => {
        state.windowCellingParams.loading = false;
        state.windowCellingParams.data = action.payload;
      })
      .addCase(fetchWindowCellingParams.rejected, (state, action) => {
        state.windowCellingParams.loading = false;
        state.windowCellingParams.error = action.payload || 'Something wents wrong';
      })

      .addCase(fetchMouldingDoorParams.pending, (state) => {
        state.mouldingDoorParams.loading = true;
        state.mouldingDoorParams.error = null;
      })
      .addCase(fetchMouldingDoorParams.fulfilled, (state, action) => {
        state.mouldingDoorParams.loading = false;
        state.mouldingDoorParams.data = action.payload;
      })
      .addCase(fetchMouldingDoorParams.rejected, (state, action) => {
        state.mouldingDoorParams.loading = false;
        state.mouldingDoorParams.error = action.payload || 'Something wents wrong';
      })

      .addCase(fetchFurnishingQciParams.pending, (state) => {
        state.furnishingQciParams.loading = true;
        state.furnishingQciParams.error = null;
      })
      .addCase(fetchFurnishingQciParams.fulfilled, (state, action) => {
        state.furnishingQciParams.loading = false;
        state.furnishingQciParams.data = action.payload;
      })
      .addCase(fetchFurnishingQciParams.rejected, (state, action) => {
        state.furnishingQciParams.loading = false;
        state.furnishingQciParams.error = action.payload || 'Something wents wrong';
      })

      .addCase(fetchTestingAirBrakeParams.pending, (state) => {
        state.testingairbrakeparams.loading = true;
        state.testingairbrakeparams.error = null;
      })
      .addCase(fetchTestingAirBrakeParams.fulfilled, (state, action) => {
        state.testingairbrakeparams.loading = false;
        state.testingairbrakeparams.data = action.payload;
      })
      .addCase(fetchTestingAirBrakeParams.rejected, (state, action) => {
        state.testingairbrakeparams.loading = false;
        state.testingairbrakeparams.error = action.payload || 'Something wents wrong';
      })

      .addCase(fetchFurnishingTestingFireParams.pending, (state) => {
        state.fireParams.loading = true;
        state.fireParams.error = null;
      })
      .addCase(fetchFurnishingTestingFireParams.fulfilled, (state, action) => {
        state.fireParams.loading = false;
        state.fireParams.data = action.payload;
      })
      .addCase(fetchFurnishingTestingFireParams.rejected, (state, action) => {
        state.fireParams.loading = false;
        state.fireParams.error = action.payload || 'Something wents wrong';
      })

      .addCase(fetchFurnishingTestingBiotoiletParams.pending, (state) => {
        state.biotoiletParams.loading = true;
        state.biotoiletParams.error = null;
      })
      .addCase(fetchFurnishingTestingBiotoiletParams.fulfilled, (state, action) => {
        state.biotoiletParams.loading = false;
        state.biotoiletParams.data = action.payload;
      })
      .addCase(fetchFurnishingTestingBiotoiletParams.rejected, (state, action) => {
        state.biotoiletParams.loading = false;
        state.biotoiletParams.error = action.payload || 'Something wents wrong';
      })

      .addCase(fetchBufferCbcParams.pending, (state) => {
        state.bufferCbcParams.loading = true;
        state.bufferCbcParams.error = null;
      })
      .addCase(fetchBufferCbcParams.fulfilled, (state, action) => {
        state.bufferCbcParams.loading = false;
        state.bufferCbcParams.data = action.payload;
      })
      .addCase(fetchBufferCbcParams.rejected, (state, action) => {
        state.bufferCbcParams.loading = false;
        state.bufferCbcParams.error = action.payload || 'Something wents wrong';
      })

      .addCase(fetchTestingBufferCbcObsparams.pending, (state) => {
        state.testingbufferCbcObs.loading = true;
        state.testingbufferCbcObs.error = null;
      })
      .addCase(fetchTestingBufferCbcObsparams.fulfilled, (state, action) => {
        state.testingbufferCbcObs.loading = false;
        state.testingbufferCbcObs.data = action.payload;
      })
      .addCase(fetchTestingBufferCbcObsparams.rejected, (state, action) => {
        state.testingbufferCbcObs.loading = false;
        state.testingbufferCbcObs.error = action.payload || 'Something wents wrong';
      })
      .addCase(fetchTestingLeakageParams.pending, (state) => {
        state.testingLeakageParams.loading = true;
        state.testingLeakageParams.error = null;
      })
      .addCase(fetchTestingLeakageParams.fulfilled, (state, action) => {
        state.testingLeakageParams.loading = false;
        state.testingLeakageParams.data = action.payload;
      })
      .addCase(fetchTestingLeakageParams.rejected, (state, action) => {
        state.testingLeakageParams.loading = false;
        state.testingLeakageParams.error = action.payload || 'Something wents wrong';
      })

      .addCase(listFloorPvc.pending, (state) => {
        state.getlistFloorPvc.loading = true;
        state.getlistFloorPvc.error = null;
        state.getlistFloorPvc.success = false;
      })
      .addCase(listFloorPvc.fulfilled, (state, action) => {
        state.getlistFloorPvc.loading = false;
        state.getlistFloorPvc.success = true;

        state.getlistFloorPvc.data = action.payload.data || [];
        state.getlistFloorPvc.pagination = {
          current_page: parseInt(action.payload.current_page, 10) || 1,
          total: parseInt(action.payload.total, 10) || 0,
          per_page: parseInt(action.payload.per_page, 10) || 10,
          total_pages: parseInt(action.payload.total_pages, 10) || 1,
        };
      })
      .addCase(listFloorPvc.rejected, (state, action) => {
        state.getlistFloorPvc.loading = false;
        state.getlistFloorPvc.success = false;
        state.getlistFloorPvc.error = action.payload || 'Failed to fetch list';
      })
      .addCase(fetchviewFloorPvc.pending, (state) => {
        state.getViewFloorPvc.loading = true;
        state.getViewFloorPvc.error = null;
      })
      .addCase(fetchviewFloorPvc.fulfilled, (state, action) => {
        state.getViewFloorPvc.loading = false;
        state.getViewFloorPvc.data = action.payload.data;
      })
      .addCase(fetchviewFloorPvc.rejected, (state, action) => {
        state.getViewFloorPvc.loading = false;
        state.getViewFloorPvc.error =
          action.payload || 'Failed to fetch floor and pvc submitted data';
      })

      .addCase(listPartition.pending, (state) => {
        state.getlistPartition.loading = true;
        state.getlistPartition.error = null;
      })
      .addCase(listPartition.fulfilled, (state, action) => {
        state.getlistPartition.loading = false;
        state.getlistPartition.success = true;

        state.getlistPartition.data = action.payload.data?.data || [];

        state.getlistPartition.pagination = action.payload.data?.pagination || {
          current_page: 1,
          last_page: 1,
          total: 0,
          per_page: 10,
        };
      })
      .addCase(listPartition.rejected, (state, action) => {
        state.getlistPartition.loading = false;
        state.getlistPartition.success = false;
        state.getlistPartition.error = action.payload || 'Failed to fetch list';
      })

      .addCase(fetchviewPartition.pending, (state) => {
        state.getViewPartition.loading = true;
        state.getViewPartition.error = null;
      })
      .addCase(fetchviewPartition.fulfilled, (state, action) => {
        state.getViewPartition.loading = false;
        state.getViewPartition.data = action.payload.data;
      })
      .addCase(fetchviewPartition.rejected, (state, action) => {
        state.getViewPartition.loading = false;
        state.getViewPartition.error = action.payload || 'Failed to fetch partition submitted data';
      })
      .addCase(saveMouldingDoor.pending, (state) => {
        state.mouldingDoorSave.loading = true;
        state.mouldingDoorSave.success = false;
        state.mouldingDoorSave.error = null;
      })
      .addCase(saveMouldingDoor.fulfilled, (state, action) => {
        state.mouldingDoorSave.loading = false;
        state.mouldingDoorSave.success = true;
        state.mouldingDoorSave.data = action.payload;
      })
      .addCase(saveMouldingDoor.rejected, (state, action) => {
        state.mouldingDoorSave.loading = false;
        state.mouldingDoorSave.success = false;
        state.mouldingDoorSave.error = action.payload || 'Something went wrong';
      })
      .addCase(fetchMouldingDoorList.pending, (state) => {
        state.mouldingDoorList.loading = true;
        state.mouldingDoorList.error = null;
      })
      .addCase(fetchMouldingDoorList.fulfilled, (state, action) => {
        state.mouldingDoorList.loading = false;
        state.mouldingDoorList.success = true;
        state.mouldingDoorList.data = action.payload?.data || [];
        state.mouldingDoorList.pagination = action.payload?.pagination || null;
      })
      .addCase(fetchMouldingDoorList.rejected, (state, action) => {
        state.mouldingDoorList.loading = false;
        state.mouldingDoorList.error = action.payload || 'Something went wrong';
      })
      .addCase(fetchMouldingDoorById.pending, (state) => {
        state.mouldingDoorDetail.loading = true;
        state.mouldingDoorDetail.error = null;
        state.mouldingDoorDetail.data = null; // clear previous
      })
      .addCase(fetchMouldingDoorById.fulfilled, (state, action) => {
        state.mouldingDoorDetail.loading = false;
        state.mouldingDoorDetail.success = true;
        state.mouldingDoorDetail.data = action.payload?.data;
      })
      .addCase(fetchMouldingDoorById.rejected, (state, action) => {
        state.mouldingDoorDetail.loading = false;
        state.mouldingDoorDetail.success = false;
        state.mouldingDoorDetail.error = action.payload || 'Something went wrong';
      })
      .addCase(savePlumbing.pending, (state) => {
        state.plumbingSave.loading = true;
        state.plumbingSave.success = false;
        state.plumbingSave.error = null;
      })
      .addCase(savePlumbing.fulfilled, (state, action) => {
        state.plumbingSave.loading = false;
        state.plumbingSave.success = true;
        state.plumbingSave.data = action.payload;
      })
      .addCase(savePlumbing.rejected, (state, action) => {
        state.plumbingSave.loading = false;
        state.plumbingSave.success = false;
        state.plumbingSave.error = action.payload || 'Something went wrong';
      })
      .addCase(fetchPlumbingList.pending, (state) => {
        state.plumbingList.loading = true;
        state.plumbingList.error = null;
      })
      .addCase(fetchPlumbingList.fulfilled, (state, action) => {
        state.plumbingList.loading = false;
        state.plumbingList.success = true;
        state.plumbingList.data = action.payload?.data || [];
        state.plumbingList.pagination = action.payload || null;
      })
      .addCase(fetchPlumbingList.rejected, (state, action) => {
        state.plumbingList.loading = false;
        state.plumbingList.error = action.payload || 'Something went wrong';
      })
      .addCase(fetchPlumbingById.pending, (state) => {
        state.plumbingDetail.loading = true;
        state.plumbingDetail.error = null;
        state.plumbingDetail.data = null;
      })
      .addCase(fetchPlumbingById.fulfilled, (state, action) => {
        state.plumbingDetail.loading = false;
        state.plumbingDetail.success = true;
        state.plumbingDetail.data = action.payload?.data;
      })
      .addCase(fetchPlumbingById.rejected, (state, action) => {
        state.plumbingDetail.loading = false;
        state.plumbingDetail.success = false;
        state.plumbingDetail.error = action.payload || 'Something went wrong';
      })
      .addCase(saveAirBrake.pending, (state) => {
        state.airBrakeSave.loading = true;
        state.airBrakeSave.success = false;
        state.airBrakeSave.error = null;
      })
      .addCase(saveAirBrake.fulfilled, (state, action) => {
        state.airBrakeSave.loading = false;
        state.airBrakeSave.success = true;
        state.airBrakeSave.data = action.payload;
      })
      .addCase(saveAirBrake.rejected, (state, action) => {
        state.airBrakeSave.loading = false;
        state.airBrakeSave.success = false;
        state.airBrakeSave.error = action.payload || 'Something went wrong';
      })

      .addCase(fetchAirBrakeList.pending, (state) => {
        state.airBrakeList.loading = true;
        state.airBrakeList.error = null;
      })
      .addCase(fetchAirBrakeList.fulfilled, (state, action) => {
        state.airBrakeList.loading = false;
        state.airBrakeList.success = true;
        state.airBrakeList.data = action.payload?.data || [];
        state.airBrakeList.pagination = action.payload || null;
      })
      .addCase(fetchAirBrakeList.rejected, (state, action) => {
        state.airBrakeList.loading = false;
        state.airBrakeList.error = action.payload || 'Something went wrong';
      })
      .addCase(fetchAirBrakeById.pending, (state) => {
        state.airBrakeDetail.loading = true;
        state.airBrakeDetail.error = null;
        state.airBrakeDetail.data = null;
      })

      .addCase(fetchTestingFibaParams.fulfilled, (state, action) => {
        state.testingFiba.loading = false;
        state.testingFiba.success = true;
        state.testingFiba.data = action.payload?.data || [];
        state.testingFiba.pagination = action.payload || null;
      })
      .addCase(fetchTestingFibaParams.rejected, (state, action) => {
        state.testingFiba.loading = false;
        state.testingFiba.error = action.payload || 'Something went wrong';
      })
      .addCase(fetchTestingFibaParams.pending, (state) => {
        state.testingFiba.loading = true;
        state.testingFiba.error = null;
        state.testingFiba.data = null;
      })

      .addCase(fetchAirBrakeById.fulfilled, (state, action) => {
        state.airBrakeDetail.loading = false;
        state.airBrakeDetail.success = true;
        state.airBrakeDetail.data = action.payload?.data;
      })
      .addCase(fetchAirBrakeById.rejected, (state, action) => {
        state.airBrakeDetail.loading = false;
        state.airBrakeDetail.success = false;
        state.airBrakeDetail.error = action.payload || 'Something went wrong';
      })
      // Store Data
      .addCase(storeWindowCeilingData.pending, (state) => {
        state.windowCeiling.loading = true;
        state.windowCeiling.error = null;
      })
      .addCase(storeWindowCeilingData.fulfilled, (state) => {
        state.windowCeiling.loading = false;
        state.windowCeiling.success = true;
      })
      .addCase(storeWindowCeilingData.rejected, (state, action) => {
        state.windowCeiling.loading = false;
        state.windowCeiling.error = action.payload || 'Something went wrong';
      })

      // Fetch List
      .addCase(fetchWindowCeilingList.pending, (state) => {
        state.windowCeiling.loading = true;
        state.windowCeiling.error = null;
      })
      .addCase(fetchWindowCeilingList.fulfilled, (state, action) => {
        state.windowCeiling.loading = false;

        state.windowCeiling.list = {
          data: action.payload.data || [],
          pagination: {
            current_page: action.payload.current_page || 1,
            per_page: action.payload.per_page || 10,
            total: action.payload.total || 0,
            total_pages: action.payload.total_pages || 0,
          },
        };
      })
      .addCase(fetchWindowCeilingList.rejected, (state, action) => {
        state.windowCeiling.loading = false;
        state.windowCeiling.error = action.payload || 'Something went wrong';
      })

      // View Data
      .addCase(viewWindowCeilingData.pending, (state) => {
        state.windowCeiling.loading = true;
        state.windowCeiling.error = null;
      })
      .addCase(viewWindowCeilingData.fulfilled, (state, action) => {
        state.windowCeiling.loading = false;
        state.windowCeiling.viewData = action.payload.data;
      })
      .addCase(viewWindowCeilingData.rejected, (state, action) => {
        state.windowCeiling.loading = false;
        state.windowCeiling.error = action.payload || 'Something went wrong';
      })

      // Delete Data
      .addCase(deleteWindowCeilingData.pending, (state) => {
        state.windowCeiling.loading = true;
        state.windowCeiling.error = null;
      })
      .addCase(deleteWindowCeilingData.fulfilled, (state) => {
        state.windowCeiling.loading = false;
        state.windowCeiling.success = true;
      })
      .addCase(deleteWindowCeilingData.rejected, (state, action) => {
        state.windowCeiling.loading = false;
        state.windowCeiling.error = action.payload || 'Something went wrong';
      })

      // Store Seat & Berth
      .addCase(storeSeatBerthData.pending, (state) => {
        state.seatBerthSave.loading = true;
        state.seatBerthSave.error = null;
      })
      .addCase(storeSeatBerthData.fulfilled, (state, action) => {
        state.seatBerthSave.loading = false;
        state.seatBerthSave.success = true;
        state.seatBerthSave.data = action.payload;
      })
      .addCase(storeSeatBerthData.rejected, (state, action) => {
        state.seatBerthSave.loading = false;
        state.seatBerthSave.error = action.payload || 'Something went wrong';
      })

      // Fetch Seat & Berth List
      .addCase(fetchSeatBerthList.pending, (state) => {
        state.seatBerthList.loading = true;
        state.seatBerthList.error = null;
      })
      .addCase(fetchSeatBerthList.fulfilled, (state, action) => {
        state.seatBerthList.loading = false;
        state.seatBerthList.data = action.payload?.data || [];
        state.seatBerthList.pagination = {
          current_page: action.payload?.current_page || 1,
          per_page: action.payload?.per_page || 10,
          total: action.payload?.total || 0,
          total_pages: action.payload?.total_pages || 0,
        };
      })
      .addCase(fetchSeatBerthList.rejected, (state, action) => {
        state.seatBerthList.loading = false;
        state.seatBerthList.error = action.payload || 'Something went wrong';
      })

      // View Seat & Berth
      .addCase(viewSeatBerthData.pending, (state) => {
        state.seatBerthView.loading = true;
        state.seatBerthView.error = null;
      })
      .addCase(viewSeatBerthData.fulfilled, (state, action) => {
        state.seatBerthView.loading = false;
        state.seatBerthView.data = action.payload?.data;
      })
      .addCase(viewSeatBerthData.rejected, (state, action) => {
        state.seatBerthView.loading = false;
        state.seatBerthView.error = action.payload || 'Something went wrong';
      })

      // Store Lavatory
      .addCase(storeLavatoryData.pending, (state) => {
        state.lavatorySave.loading = true;
        state.lavatorySave.error = null;
      })
      .addCase(storeLavatoryData.fulfilled, (state, action) => {
        state.lavatorySave.loading = false;
        state.lavatorySave.success = true;
        state.lavatorySave.data = action.payload;
      })
      .addCase(storeLavatoryData.rejected, (state, action) => {
        state.lavatorySave.loading = false;
        state.lavatorySave.error = action.payload || 'Something went wrong';
      })

      // Fetch Lavatory List
      .addCase(fetchLavatoryList.pending, (state) => {
        state.lavatoryList.loading = true;
        state.lavatoryList.error = null;
      })
      .addCase(fetchLavatoryList.fulfilled, (state, action) => {
        state.lavatoryList.loading = false;
        state.lavatoryList.data = action.payload?.data || [];
        state.lavatoryList.pagination = {
          current_page: action.payload?.current_page || 1,
          per_page: action.payload?.per_page || 10,
          total: action.payload?.total || 0,
          total_pages: action.payload?.total_pages || 0,
        };
      })
      .addCase(fetchLavatoryList.rejected, (state, action) => {
        state.lavatoryList.loading = false;
        state.lavatoryList.error = action.payload || 'Something went wrong';
      })

      // View Lavatory
      .addCase(viewLavatoryData.pending, (state) => {
        state.lavatoryView.loading = true;
        state.lavatoryView.error = null;
      })
      .addCase(viewLavatoryData.fulfilled, (state, action) => {
        state.lavatoryView.loading = false;
        state.lavatoryView.data = action.payload?.data;
      })
      .addCase(viewLavatoryData.rejected, (state, action) => {
        state.lavatoryView.loading = false;
        state.lavatoryView.error = action.payload || 'Something went wrong';
      })
      //panneling

      .addCase(listPanneling.pending, (state) => {
        state.getlistPanneling.loading = true;
        state.getlistPanneling.error = null;
      })
      .addCase(listPanneling.fulfilled, (state, action) => {
        state.getlistPanneling.loading = false;
        state.getlistPanneling.success = true;

        state.getlistPanneling.data = action.payload.data?.data || [];

        state.getlistPanneling.pagination = action.payload.data?.pagination || {
          current_page: 1,
          last_page: 1,
          total: 0,
          per_page: 10,
        };
      })
      .addCase(listPanneling.rejected, (state, action) => {
        state.getlistPanneling.loading = false;
        state.getlistPanneling.success = false;
        state.getlistPanneling.error = action.payload || 'Failed to fetch list';
      })

      .addCase(fetchviewPanneling.pending, (state) => {
        state.getViewPanneling.loading = true;
        state.getViewPanneling.error = null;
      })
      .addCase(fetchviewPanneling.fulfilled, (state, action) => {
        state.getViewPanneling.loading = false;
        state.getViewPanneling.data = action.payload.data;
      })
      .addCase(fetchviewPanneling.rejected, (state, action) => {
        state.getViewPanneling.loading = false;
        state.getViewPanneling.error = action.payload || 'Failed to fetch panneling submitted data';
      })

      .addCase(fetchShellNo.pending, (state) => {
        state.getShellNo.loading = true;
        state.getShellNo.error = null;
      })
      .addCase(fetchShellNo.fulfilled, (state, action) => {
        state.getShellNo.loading = false;
        state.getShellNo.data = action.payload.data;
      })
      .addCase(fetchShellNo.rejected, (state, action) => {
        state.getShellNo.loading = false;
        state.getShellNo.error = action.payload || 'Failed to shell no data';
      })
      .addCase(fetchMouldingDoorFlowHistory.pending, (state) => {
        state.mouldingDoorFlowHistory.loading = true;
        state.mouldingDoorFlowHistory.error = null;
      })
      .addCase(fetchMouldingDoorFlowHistory.fulfilled, (state, action) => {
        state.mouldingDoorFlowHistory.loading = false;
        state.mouldingDoorFlowHistory.success = true;
        state.mouldingDoorFlowHistory.data = action.payload?.data || [];
      })
      .addCase(fetchMouldingDoorFlowHistory.rejected, (state, action) => {
        state.mouldingDoorFlowHistory.loading = false;
        state.mouldingDoorFlowHistory.error = action.payload || 'Something went wrong';
      })
      .addCase(fetchPlumbingFlowHistory.pending, (state) => {
        state.plumbingFlowHistory.loading = true;
        state.plumbingFlowHistory.error = null;
      })
      .addCase(fetchPlumbingFlowHistory.fulfilled, (state, action) => {
        state.plumbingFlowHistory.loading = false;
        state.plumbingFlowHistory.success = true;
        state.plumbingFlowHistory.data = action.payload?.data || [];
      })
      .addCase(fetchPlumbingFlowHistory.rejected, (state, action) => {
        state.plumbingFlowHistory.loading = false;
        state.plumbingFlowHistory.error = action.payload || 'Something went wrong';
      })
      .addCase(airBrakeFlowHistory.pending, (state) => {
        state.airBrakeFlowHistory.loading = true;
        state.airBrakeFlowHistory.error = null;
      })
      .addCase(airBrakeFlowHistory.fulfilled, (state, action) => {
        state.airBrakeFlowHistory.loading = false;
        state.airBrakeFlowHistory.success = true;
        state.airBrakeFlowHistory.data = action.payload?.data || [];
      })
      .addCase(airBrakeFlowHistory.rejected, (state, action) => {
        state.airBrakeFlowHistory.loading = false;
        state.airBrakeFlowHistory.error = action.payload || 'Something went wrong';
      })
      .addCase(updateFurnishingStatus.pending, (state) => {
        state.furnishingStatus.loading = true;
        state.furnishingStatus.error = null;
      })
      .addCase(updateFurnishingStatus.fulfilled, (state, action) => {
        state.furnishingStatus.loading = false;
        state.furnishingStatus.success = true;
        state.furnishingStatus.data = action.payload;
      })
      .addCase(updateFurnishingStatus.rejected, (state, action) => {
        state.furnishingStatus.loading = false;
        state.furnishingStatus.error = action.payload || 'Something went wrong';
      })

      // Fetch History
      .addCase(fetchFurnishingFlowHistory.pending, (state) => {
        state.furnishingHistory.loading = true;
        state.furnishingHistory.error = null;
      })
      .addCase(fetchFurnishingFlowHistory.fulfilled, (state, action) => {
        state.furnishingHistory.loading = false;
        state.furnishingHistory.success = true;
        state.furnishingHistory.data = action.payload.data?.history || [];
        state.furnishingHistory.application = action.payload.data?.application || null;
      })
      .addCase(fetchFurnishingFlowHistory.rejected, (state, action) => {
        state.furnishingHistory.loading = false;
        state.furnishingHistory.error = action.payload || 'Something went wrong';
      })

      .addCase(fetchFurnishingHistoryFlow.pending, (state) => {
        state.flowHistory.loading = true;
        state.flowHistory.error = null;
      })
      .addCase(fetchFurnishingHistoryFlow.fulfilled, (state, action) => {
        state.flowHistory.loading = false;
        state.flowHistory.data = action.payload.data;
      })
      .addCase(fetchFurnishingHistoryFlow.rejected, (state, action) => {
        state.flowHistory.loading = false;
        state.flowHistory.error = action.payload || 'Failed to fetch history';
      })

      //fire

      .addCase(listTestingFire.pending, (state) => {
        state.getListTestingFire.loading = true;
        state.getListTestingFire.error = null;
      })
      .addCase(listTestingFire.fulfilled, (state, action) => {
        state.getListTestingFire.loading = false;
        state.getListTestingFire.success = true;

        state.getListTestingFire.data = action.payload.data?.data || [];

        state.getListTestingFire.pagination = action.payload.data?.pagination || {
          current_page: 1,
          last_page: 1,
          total: 0,
          per_page: 10,
        };
      })
      .addCase(listTestingFire.rejected, (state, action) => {
        state.getListTestingFire.loading = false;
        state.getListTestingFire.success = false;
        state.getListTestingFire.error = action.payload || 'Failed to fetch list';
      })

      .addCase(fetchviewFire.pending, (state) => {
        state.getViewFire.loading = true;
        state.getViewFire.error = null;
      })
      .addCase(fetchviewFire.fulfilled, (state, action) => {
        state.getViewFire.loading = false;
        state.getViewFire.data = action.payload.data;
      })
      .addCase(fetchviewFire.rejected, (state, action) => {
        state.getViewFire.loading = false;
        state.getViewFire.error = action.payload || 'Failed to fetch fire submitted data';
      })

      .addCase(listBiotoilet.pending, (state) => {
        state.getListBiotoilet.loading = true;
        state.getListBiotoilet.error = null;
      })
      .addCase(listBiotoilet.fulfilled, (state, action) => {
        state.getListBiotoilet.loading = false;
        state.getListBiotoilet.success = true;

        state.getListBiotoilet.data = action.payload.data?.data || [];

        state.getListBiotoilet.pagination = action.payload.data?.pagination || {
          current_page: 1,
          last_page: 1,
          total: 0,
          per_page: 10,
        };
      })
      .addCase(listBiotoilet.rejected, (state, action) => {
        state.getListBiotoilet.loading = false;
        state.getListBiotoilet.success = false;
        state.getListBiotoilet.error = action.payload || 'Failed to fetch list';
      })
      .addCase(fetchViewBiotoilet.pending, (state) => {
        state.getViewBiotoilet.loading = true;
        state.getViewBiotoilet.error = null;
      })
      .addCase(fetchViewBiotoilet.fulfilled, (state, action) => {
        state.getViewBiotoilet.loading = false;
        state.getViewBiotoilet.data = action.payload.data;
      })
      .addCase(fetchViewBiotoilet.rejected, (state, action) => {
        state.getViewBiotoilet.loading = false;
        state.getViewBiotoilet.error = action.payload || 'Failed to fetch biotoilet submitted data';
      })

      .addCase(listLeakage.pending, (state) => {
        state.getListLeakage.loading = true;
        state.getListLeakage.error = null;
      })
      .addCase(listLeakage.fulfilled, (state, action) => {
        state.getListLeakage.loading = false;
        state.getListLeakage.success = true;

        state.getListLeakage.data = action.payload.data?.data || [];

        state.getListLeakage.pagination = action.payload.data?.pagination || {
          current_page: 1,
          last_page: 1,
          total: 0,
          per_page: 10,
        };
      })
      .addCase(listLeakage.rejected, (state, action) => {
        state.getListLeakage.loading = false;
        state.getListLeakage.success = false;
        state.getListLeakage.error = action.payload || 'Failed to fetch list';
      })

      .addCase(fetchviewLeakage.pending, (state) => {
        state.getViewLeakage.loading = true;
        state.getViewLeakage.error = null;
      })
      .addCase(fetchviewLeakage.fulfilled, (state, action) => {
        state.getViewLeakage.loading = false;
        state.getViewLeakage.data = action.payload.data;
      })
      .addCase(fetchviewLeakage.rejected, (state, action) => {
        state.getViewLeakage.loading = false;
        state.getViewLeakage.error = action.payload || 'Failed to fetch leakage submitted data';
      })
      .addCase(saveFurnishingQciData.pending, (state) => {
        state.furnishingQciDataSave.loading = true;
        state.furnishingQciDataSave.success = false;
        state.furnishingQciDataSave.error = null;
      })
      .addCase(saveFurnishingQciData.fulfilled, (state, action) => {
        state.furnishingQciDataSave.loading = false;
        state.furnishingQciDataSave.success = true;
        state.furnishingQciDataSave.data = action.payload;
      })
      .addCase(saveFurnishingQciData.rejected, (state, action) => {
        state.furnishingQciDataSave.loading = false;
        state.furnishingQciDataSave.success = false;
        state.furnishingQciDataSave.error = action.payload || 'Something went wrong';
      })
      .addCase(fetchFurnishingQciList.pending, (state) => {
        state.furnishingQciList.loading = true;
        state.furnishingQciList.error = null;
      })
      .addCase(fetchFurnishingQciList.fulfilled, (state, action) => {
        state.furnishingQciList.loading = false;
        state.furnishingQciList.success = true;
        state.furnishingQciList.data = action.payload?.data || [];
        state.furnishingQciList.pagination = action.payload || null;
      })
      .addCase(fetchFurnishingQciList.rejected, (state, action) => {
        state.furnishingQciList.loading = false;
        state.furnishingQciList.success = false;
        state.furnishingQciList.error = action.payload || 'Something went wrong';
      })
      .addCase(viewFurnishingQciAssembly.pending, (state) => {
        state.viewFurnishingQciAssembly.loading = true;
        state.viewFurnishingQciAssembly.error = null;
      })
      .addCase(viewFurnishingQciAssembly.fulfilled, (state, action) => {
        state.viewFurnishingQciAssembly.loading = false;
        state.viewFurnishingQciAssembly.success = true;
        state.viewFurnishingQciAssembly.data = action.payload?.data;
      })
      .addCase(viewFurnishingQciAssembly.rejected, (state, action) => {
        state.viewFurnishingQciAssembly.loading = false;
        state.viewFurnishingQciAssembly.success = false;
        state.viewFurnishingQciAssembly.error = action.payload || 'Something went wrong';
      })
      .addCase(fetchFurnishingQciStageById.pending, (state) => {
        state.furnishingQciStageDetail.loading = true;
        state.furnishingQciStageDetail.error = null;
      })
      .addCase(fetchFurnishingQciStageById.fulfilled, (state, action) => {
        state.furnishingQciStageDetail.loading = false;
        state.furnishingQciStageDetail.success = true;
        state.furnishingQciStageDetail.data = action.payload?.data;
      })
      .addCase(fetchFurnishingQciStageById.rejected, (state, action) => {
        state.furnishingQciStageDetail.loading = false;
        state.furnishingQciStageDetail.success = false;
        state.furnishingQciStageDetail.error = action.payload || 'Something went wrong';
      })
      .addCase(furnishingQciInspectionAction.pending, (state) => {
        state.furnishingQciAction.loading = true;
        state.furnishingQciAction.error = null;
      })
      .addCase(furnishingQciInspectionAction.fulfilled, (state, action) => {
        state.furnishingQciAction.loading = false;
        state.furnishingQciAction.success = true;
        state.furnishingQciAction.data = action.payload;
      })
      .addCase(furnishingQciInspectionAction.rejected, (state, action) => {
        state.furnishingQciAction.loading = false;
        state.furnishingQciAction.error = action.payload || 'Something went wrong';
      })

      .addCase(fetchFurnishingQciFlowHistory.pending, (state) => {
        state.furnishingQciFlowHistory.loading = true;
        state.furnishingQciFlowHistory.error = null;
      })
      .addCase(fetchFurnishingQciFlowHistory.fulfilled, (state, action) => {
        state.furnishingQciFlowHistory.loading = false;
        state.furnishingQciFlowHistory.success = true;
        state.furnishingQciFlowHistory.data = action.payload?.data || [];
      })
      .addCase(fetchFurnishingQciFlowHistory.rejected, (state, action) => {
        state.furnishingQciFlowHistory.loading = false;
        state.furnishingQciFlowHistory.error = action.payload || 'Something went wrong';
      })
      .addCase(deleteFurnishingQci.pending, (state) => {
        state.furnishingQciDelete.loading = true;
        state.furnishingQciDelete.error = null;
      })
      .addCase(deleteFurnishingQci.fulfilled, (state) => {
        state.furnishingQciDelete.loading = false;
        state.furnishingQciDelete.success = true;
      })
      .addCase(deleteFurnishingQci.rejected, (state, action) => {
        state.furnishingQciDelete.loading = false;
        state.furnishingQciDelete.error = action.payload || 'Something went wrong';
      })
      .addCase(fetchFurnishingQciCompletedStages.pending, (state) => {
        state.furnishingQciCompletedStages.loading = true;
        state.furnishingQciCompletedStages.error = null;
      })
      .addCase(fetchFurnishingQciCompletedStages.fulfilled, (state, action) => {
        state.furnishingQciCompletedStages.loading = false;
        state.furnishingQciCompletedStages.success = true;
        state.furnishingQciCompletedStages.data = action.payload?.data?.completed_stages || [];
      })
      .addCase(fetchFurnishingQciCompletedStages.rejected, (state, action) => {
        state.furnishingQciCompletedStages.loading = false;
        state.furnishingQciCompletedStages.error = action.payload || 'Something went wrong';
      })

      .addCase(fetchFireHistoryFlow.pending, (state) => {
        state.getFireflowHistory.loading = true;
        state.getFireflowHistory.error = null;
      })
      .addCase(fetchFireHistoryFlow.fulfilled, (state, action) => {
        state.getFireflowHistory.loading = false;
        state.getFireflowHistory.data = action.payload.data;
      })
      .addCase(fetchFireHistoryFlow.rejected, (state, action) => {
        state.getFireflowHistory.loading = false;
        state.getFireflowHistory.error = action.payload || 'Failed to fetch history';
      })

      .addCase(fetchLeakageHistoryFlow.pending, (state) => {
        state.getLeakageflowHistory.loading = true;
        state.getLeakageflowHistory.error = null;
      })
      .addCase(fetchLeakageHistoryFlow.fulfilled, (state, action) => {
        state.getLeakageflowHistory.loading = false;
        state.getLeakageflowHistory.data = action.payload.data;
      })
      .addCase(fetchLeakageHistoryFlow.rejected, (state, action) => {
        state.getLeakageflowHistory.loading = false;
        state.getLeakageflowHistory.error = action.payload || 'Failed to fetch history';
      })

      .addCase(fetchBiotoiletHistoryFlow.pending, (state) => {
        state.getBoitoiletflowHistory.loading = true;
        state.getBoitoiletflowHistory.error = null;
      })
      .addCase(fetchBiotoiletHistoryFlow.fulfilled, (state, action) => {
        state.getBoitoiletflowHistory.loading = false;
        state.getBoitoiletflowHistory.data = action.payload.data;
      })
      .addCase(fetchBiotoiletHistoryFlow.rejected, (state, action) => {
        state.getBoitoiletflowHistory.loading = false;
        state.getBoitoiletflowHistory.error = action.payload || 'Failed to fetch history';
      })

      .addCase(checkExistRecord.pending, (state) => {
        state.existingRecordDetails.loading = true;
        state.existingRecordDetails.error = null;
      })
      .addCase(checkExistRecord.fulfilled, (state, action) => {
        state.existingRecordDetails.loading = false;
        state.existingRecordDetails.data = action.payload.data;
      })
      .addCase(checkExistRecord.rejected, (state, action) => {
        state.existingRecordDetails.loading = false;
        state.existingRecordDetails.error = action.payload || 'Failed to fetch history';
      })

      .addCase(fetchPvcTypeExists.pending, (state) => {
        state.getPvcTypeExists.loading = true;
        state.getPvcTypeExists.error = null;
      })
      .addCase(fetchPvcTypeExists.fulfilled, (state, action) => {
        state.getPvcTypeExists.loading = false;
        state.getPvcTypeExists.data = action.payload.data;
      })
      .addCase(fetchPvcTypeExists.rejected, (state, action) => {
        state.getPvcTypeExists.loading = false;
        state.getPvcTypeExists.error = action.payload || 'Failed to fetch pvc';
      })

      .addCase(viewFloorPvcAssembly.pending, (state) => {
        state.getviewFloorPvcStage.loading = true;
        state.getviewFloorPvcStage.error = null;
      })
      .addCase(viewFloorPvcAssembly.fulfilled, (state, action) => {
        state.getviewFloorPvcStage.loading = false;
        state.getviewFloorPvcStage.data = action.payload.data;
      })
      .addCase(viewFloorPvcAssembly.rejected, (state, action) => {
        state.getviewFloorPvcStage.loading = false;
        state.getviewFloorPvcStage.error = action.payload || 'Failed to fetch view data';
      })

      .addCase(fetchFloorPvcFlowHistory.pending, (state) => {
        state.getviewFloorPvcFlowHistory.loading = true;
        state.getviewFloorPvcFlowHistory.error = null;
      })
      .addCase(fetchFloorPvcFlowHistory.fulfilled, (state, action) => {
        state.getviewFloorPvcFlowHistory.loading = false;
        state.getviewFloorPvcFlowHistory.data = action.payload.data || [];
      })
      .addCase(fetchFloorPvcFlowHistory.rejected, (state, action) => {
        state.getviewFloorPvcFlowHistory.loading = false;
        state.getviewFloorPvcFlowHistory.error = action.payload || 'Failed to fetch history data';
      })
      .addCase(viewWindowCeilingStage.pending, (state) => {
        state.getViewWindowCeilingStage.loading = true;
        state.getViewWindowCeilingStage.error = null;
      })
      .addCase(viewWindowCeilingStage.fulfilled, (state, action) => {
        state.getViewWindowCeilingStage.loading = false;
        state.getViewWindowCeilingStage.data = action.payload.data;
      })
      .addCase(viewWindowCeilingStage.rejected, (state, action) => {
        state.getViewWindowCeilingStage.loading = false;
        state.getViewWindowCeilingStage.error = action.payload || 'Failed to fetch view data';
      })

      .addCase(fetchWindowCeilingNonAcFlowHistory.pending, (state) => {
        state.getWindowCeilingNonAcFlowHistory.loading = true;
        state.getWindowCeilingNonAcFlowHistory.error = null;
      })
      .addCase(fetchWindowCeilingNonAcFlowHistory.fulfilled, (state, action) => {
        state.getWindowCeilingNonAcFlowHistory.loading = false;
        state.getWindowCeilingNonAcFlowHistory.data = action.payload.data || [];
      })
      .addCase(fetchWindowCeilingNonAcFlowHistory.rejected, (state, action) => {
        state.getWindowCeilingNonAcFlowHistory.loading = false;
        state.getWindowCeilingNonAcFlowHistory.error =
          action.payload || 'Failed to fetch history data';
      })

      .addCase(fetchRoomTypes.pending, (state) => {
        state.roomTypes.loading = true;
        state.roomTypes.error = null;
      })
      .addCase(fetchRoomTypes.fulfilled, (state, action) => {
        state.roomTypes.loading = false;
        state.roomTypes.data = action.payload.data || [];
      })
      .addCase(fetchRoomTypes.rejected, (state, action) => {
        state.roomTypes.loading = false;
        state.roomTypes.error = action.payload || 'Failed to fetch data';
      })

      .addCase(getIcFormParams.pending, (state) => {
        state.icFormParams.loading = true;
        state.icFormParams.success = false;
        state.icFormParams.error = null;
      })
      .addCase(getIcFormParams.fulfilled, (state, action) => {
        state.icFormParams.loading = false;
        state.icFormParams.success = true;
        state.icFormParams.data = action.payload?.data || [];
      })
      .addCase(getIcFormParams.rejected, (state, action) => {
        state.icFormParams.loading = false;
        state.icFormParams.success = false;
        state.icFormParams.error = action.payload || 'Failed to fetch IC door form params';
      })

      .addCase(getDcouplingParams.pending, (state) => {
        state.dCouplingParams.loading = true;
        state.dCouplingParams.success = false;
        state.dCouplingParams.error = null;
      })
      .addCase(getDcouplingParams.fulfilled, (state, action) => {
        state.dCouplingParams.loading = false;
        state.dCouplingParams.success = true;
        state.dCouplingParams.data = action.payload?.data || [];
      })
      .addCase(getDcouplingParams.rejected, (state, action) => {
        state.dCouplingParams.loading = false;
        state.dCouplingParams.success = false;
        state.dCouplingParams.error = action.payload || 'Failed to fetch dcoupling form params';
      })

      .addCase(fetchFurnishingQciLastStageData.pending, (state) => {
        state.furnishingQciLastStageData.loading = true;
        state.furnishingQciLastStageData.error = null;
        state.furnishingQciLastStageData.data = null;
      })
      .addCase(fetchFurnishingQciLastStageData.fulfilled, (state, action) => {
        state.furnishingQciLastStageData.loading = false;
        state.furnishingQciLastStageData.data = action.payload.data || [];
      })
      .addCase(fetchFurnishingQciLastStageData.rejected, (state, action) => {
        state.furnishingQciLastStageData.loading = false;
        state.furnishingQciLastStageData.error = action.payload || 'Failed to fetch data';
      })
      .addCase(fetchViewFloorBoard.pending, (state) => {
        state.getViewFloorBoard.loading = true;
        state.getViewFloorBoard.error = null;
      })
      .addCase(fetchViewFloorBoard.fulfilled, (state, action) => {
        state.getViewFloorBoard.loading = false;
        state.getViewFloorBoard.data = action.payload.data;
      })
      .addCase(fetchViewFloorBoard.rejected, (state, action) => {
        state.getViewFloorBoard.loading = false;
        state.getViewFloorBoard.error =
          action.payload || 'Failed to fetch floor board submitted data';
      })
      .addCase(listFloorBoard.pending, (state) => {
        state.getlistFloorBoard.loading = true;
        state.getlistFloorBoard.error = null;
      })
      .addCase(listFloorBoard.fulfilled, (state, action) => {
        state.getlistFloorBoard.loading = false;
        state.getlistFloorBoard.success = true;
        state.getlistFloorBoard.data = action.payload?.data || [];
        state.getlistFloorBoard.pagination = {
          current_page: action.payload?.current_page || 1,
          per_page: action.payload?.per_page || 10,
          total: action.payload?.total || 0,
          total_pages: action.payload?.total_pages || 1,
        };
      })
      .addCase(listFloorBoard.rejected, (state, action) => {
        state.getlistFloorBoard.loading = false;
        state.getlistFloorBoard.success = false;
        state.getlistFloorBoard.error = action.payload || 'Failed to fetch list';
        state.getlistFloorBoard.data = [];
        state.getlistFloorBoard.pagination = {
          current_page: 1,
          per_page: 10,
          total: 0,
          total_pages: 1,
        };
      })
      .addCase(fetchFloorBoardParams.pending, (state) => {
        state.floorBoardParams.loading = true;
        state.floorBoardParams.error = null;
      })
      .addCase(fetchFloorBoardParams.fulfilled, (state, action) => {
        state.floorBoardParams.loading = false;
        state.floorBoardParams.data = action.payload;
      })
      .addCase(fetchFloorBoardParams.rejected, (state, action) => {
        state.floorBoardParams.loading = false;
        state.floorBoardParams.error = action.payload || 'Something wents wrong';
      })
      .addCase(fetchSafFloorPvcParams.pending, (state) => {
        state.floorSafPvcParams.loading = true;
        state.floorSafPvcParams.error = null;
      })
      .addCase(fetchSafFloorPvcParams.fulfilled, (state, action) => {
        state.floorSafPvcParams.loading = false;
        state.floorSafPvcParams.data = action.payload;
      })
      .addCase(fetchSafFloorPvcParams.rejected, (state, action) => {
        state.floorSafPvcParams.loading = false;
        state.floorSafPvcParams.error = action.payload || 'Something wents wrong';
      })
      .addCase(fetchViewSafFloorPvc.pending, (state) => {
        state.getViewSafFloorPvc.loading = true;
        state.getViewSafFloorPvc.error = null;
      })
      .addCase(fetchViewSafFloorPvc.fulfilled, (state, action) => {
        state.getViewSafFloorPvc.loading = false;
        state.getViewSafFloorPvc.data = action.payload.data;
      })
      .addCase(fetchViewSafFloorPvc.rejected, (state, action) => {
        state.getViewSafFloorPvc.loading = false;
        state.getViewSafFloorPvc.error =
          action.payload || 'Failed to fetch floor pvc submitted data';
      })
      // Plug Door Params
      .addCase(fetchPlugDoorParams.pending, (state) => {
        state.loading = true;
        state.plugDoorData.loading = true;
        state.plugDoorData.error = null;
      })
      .addCase(fetchPlugDoorParams.fulfilled, (state, action) => {
        state.loading = false;
        state.plugDoorData.loading = false;
        state.plugDoorData.success = true;
        state.plugDoorData.data = action.payload?.data || [];
      })
      .addCase(fetchPlugDoorParams.rejected, (state, action) => {
        state.loading = false;
        state.plugDoorData.loading = false;
        state.plugDoorData.success = false;
        state.plugDoorData.error = action.payload || 'Failed to fetch plugdoor params';
      })

      // Gangway params

      .addCase(fetchGangwayParams.pending, (state) => {
        state.gangwayParams.loading = true;
        state.gangwayParams.success = false;
        state.gangwayParams.error = null;
      })
      .addCase(fetchGangwayParams.fulfilled, (state, action) => {
        state.gangwayParams.loading = false;
        state.gangwayParams.success = true;
        state.gangwayParams.data = action.payload?.data || [];
      })
      .addCase(fetchGangwayParams.rejected, (state, action) => {
        state.gangwayParams.loading = false;
        state.gangwayParams.success = false;
        state.gangwayParams.error = action.payload || 'Failed to fetch gangway form params';
      })

      // Glasswool params

      .addCase(fetchGlasswoolParams.pending, (state) => {
        state.glasswoolParams.loading = true;
        state.glasswoolParams.success = false;
        state.glasswoolParams.error = null;
      })
      .addCase(fetchGlasswoolParams.fulfilled, (state, action) => {
        state.glasswoolParams.loading = false;
        state.glasswoolParams.success = true;
        state.glasswoolParams.data = action.payload?.data || [];
      })
      .addCase(fetchGlasswoolParams.rejected, (state, action) => {
        state.glasswoolParams.loading = false;
        state.glasswoolParams.success = false;
        state.glasswoolParams.error = action.payload || 'Failed to fetch glasswool form params';
      })

      // SafWindow params

      .addCase(fetchSafWindowParams.pending, (state) => {
        state.safWindowParams.loading = true;
        state.safWindowParams.success = false;
        state.safWindowParams.error = null;
      })
      .addCase(fetchSafWindowParams.fulfilled, (state, action) => {
        state.safWindowParams.loading = false;
        state.safWindowParams.success = true;
        state.safWindowParams.data = action.payload?.data || [];
      })
      .addCase(fetchSafWindowParams.rejected, (state, action) => {
        state.safWindowParams.loading = false;
        state.safWindowParams.success = false;
        state.safWindowParams.error = action.payload || 'Failed to fetch window form params';
      })

      // SafPartition params

      .addCase(fetchSafPartitionParams.pending, (state) => {
        state.safPartitionParams.loading = true;
        state.safPartitionParams.success = false;
        state.safPartitionParams.error = null;
      })
      .addCase(fetchSafPartitionParams.fulfilled, (state, action) => {
        state.safPartitionParams.loading = false;
        state.safPartitionParams.success = true;
        state.safPartitionParams.data = action.payload?.data || [];
      })
      .addCase(fetchSafPartitionParams.rejected, (state, action) => {
        state.safPartitionParams.loading = false;
        state.safPartitionParams.success = false;
        state.safPartitionParams.error = action.payload || 'Failed to fetch partition form params';
      })

      .addCase(addDCoupling.pending, (state) => {
        state.dcoupligStoreData.loading = true;
        state.dcoupligStoreData.error = null;
      })
      .addCase(addDCoupling.fulfilled, (state, action) => {
        state.dcoupligStoreData.loading = false;
        state.dcoupligStoreData.data = action.payload.data;
      })
      .addCase(addDCoupling.rejected, (state, action) => {
        state.dcoupligStoreData.loading = false;
        state.dcoupligStoreData.error =
          action.payload || 'Failed to fetch floor pvc submitted data';
      })
      .addCase(fetchListDcouplingData.pending, (state) => {
        state.DCouplingListData.loading = true;
        state.DCouplingListData.error = null;
      })
      .addCase(fetchListDcouplingData.fulfilled, (state, action) => {
        state.DCouplingListData.loading = false;
        state.DCouplingListData.data = action.payload.data;
      })
      .addCase(fetchListDcouplingData.rejected, (state, action) => {
        state.DCouplingListData.loading = false;
        state.DCouplingListData.error =
          action.payload || 'Failed to fetch floor pvc submitted data';
      })
      .addCase(fetchDCouplingById.pending, (state) => {
        state.dCouplingDetail.loading = true;
        state.dCouplingDetail.error = null;
      })
      .addCase(fetchDCouplingById.fulfilled, (state, action) => {
        state.dCouplingDetail.loading = false;
        state.dCouplingDetail.data = action.payload.data;
        state.dCouplingDetail.pagination = {
          current_page: action.payload?.current_page || 1,
          per_page: action.payload?.per_page || 10,
          total: action.payload?.total || 0,
          total_pages: action.payload?.total_pages || 0,
        };
      })
      .addCase(fetchDCouplingById.rejected, (state, action) => {
        state.dCouplingDetail.loading = false;
        state.dCouplingDetail.error = action.payload || 'Failed to fetch floor pvc submitted data';
      })
      .addCase(fetchDCouplingFlowHistory.pending, (state) => {
        state.dCouplingFlowHistory.loading = true;
        state.dCouplingFlowHistory.error = null;
      })
      .addCase(fetchDCouplingFlowHistory.fulfilled, (state, action) => {
        state.dCouplingFlowHistory.loading = false;
        state.dCouplingFlowHistory.data = action.payload.data;
      })
      .addCase(fetchDCouplingFlowHistory.rejected, (state, action) => {
        state.dCouplingFlowHistory.loading = false;
        state.dCouplingFlowHistory.error =
          action.payload || 'Failed to fetch floor pvc submitted data';
      })

      .addCase(getAcDuctParams.pending, (state) => {
        state.acDuctParams.loading = true;
        state.acDuctParams.success = false;
        state.acDuctParams.error = null;
      })
      .addCase(getAcDuctParams.fulfilled, (state, action) => {
        state.acDuctParams.loading = false;
        state.acDuctParams.success = true;
        state.acDuctParams.data = action.payload?.data || [];
      })
      .addCase(getAcDuctParams.rejected, (state, action) => {
        state.acDuctParams.loading = false;
        state.acDuctParams.success = false;
        state.acDuctParams.error = action.payload || 'Failed to fetch acduct form params';
      })
      .addCase(fetchListGangwayData.pending, (state) => {
        state.GangwayListData.loading = true;
        state.GangwayListData.success = false;
        state.GangwayListData.error = null;
      })
      .addCase(fetchListGangwayData.fulfilled, (state, action) => {
        state.GangwayListData.loading = false;
        state.GangwayListData.success = true;
        state.GangwayListData.data = action.payload?.data || [];
        state.GangwayListData.pagination = {
          current_page: action.payload?.current_page || 1,
          per_page: action.payload?.per_page || 10,
          total: action.payload?.total || 0,
          total_pages: action.payload?.total_pages || 0,
        };
      })
      .addCase(fetchListGangwayData.rejected, (state, action) => {
        state.GangwayListData.loading = false;
        state.GangwayListData.success = false;
        state.GangwayListData.error = action.payload || 'Failed to fetch acduct form params';
      })
      .addCase(addGangway.pending, (state) => {
        state.gangwayStoreData.loading = true;
        state.gangwayStoreData.error = null;
      })
      .addCase(addGangway.fulfilled, (state, action) => {
        state.gangwayStoreData.loading = false;
        state.gangwayStoreData.data = action.payload.data;
      })
      .addCase(addGangway.rejected, (state, action) => {
        state.gangwayStoreData.loading = false;
        state.gangwayStoreData.error = action.payload || 'Failed to fetch floor pvc submitted data';
      })
      .addCase(fetchGangwayById.pending, (state) => {
        state.gangwayDetail.loading = true;
        state.gangwayDetail.error = null;
      })
      .addCase(fetchGangwayById.fulfilled, (state, action) => {
        state.gangwayDetail.loading = false;
        state.gangwayDetail.data = action.payload.data;
      })
      .addCase(fetchGangwayById.rejected, (state, action) => {
        state.gangwayDetail.loading = false;
        state.gangwayDetail.error = action.payload || 'Failed to fetch floor pvc submitted data';
      })
      .addCase(fetchGangwayFlowHistory.pending, (state) => {
        state.gangwayFlowHistory.loading = true;
        state.gangwayFlowHistory.error = null;
      })
      .addCase(fetchGangwayFlowHistory.fulfilled, (state, action) => {
        state.gangwayFlowHistory.loading = false;
        state.gangwayFlowHistory.data = action.payload.data;
      })
      .addCase(fetchGangwayFlowHistory.rejected, (state, action) => {
        state.gangwayFlowHistory.loading = false;
        state.gangwayFlowHistory.error =
          action.payload || 'Failed to fetch floor pvc submitted data';
      })
      .addCase(addAcDuctData.pending, (state) => {
        state.acDuctStoreData.loading = true;
        state.acDuctStoreData.error = null;
      })
      .addCase(addAcDuctData.fulfilled, (state, action) => {
        state.acDuctStoreData.loading = false;
        state.acDuctStoreData.data = action.payload.data;
      })
      .addCase(addAcDuctData.rejected, (state, action) => {
        state.acDuctStoreData.loading = false;
        state.acDuctStoreData.error = action.payload || 'Failed to fetch floor pvc submitted data';
      })

      .addCase(fetchFloorBoardHistory.pending, (state) => {
        state.floorBoardHistory.loading = true;
        state.floorBoardHistory.error = null;
      })
      .addCase(fetchFloorBoardHistory.fulfilled, (state, action) => {
        state.floorBoardHistory.loading = false;
        state.floorBoardHistory.data = action.payload.data;
      })
      .addCase(fetchFloorBoardHistory.rejected, (state, action) => {
        state.floorBoardHistory.loading = false;
        state.floorBoardHistory.error = action.payload || 'Failed to fetch history';
        state.floorBoardHistory.data = null;
      })

      .addCase(listSafVbFloorBoard.pending, (state) => {
        state.getlistVbFloorPvc.loading = true;
        state.getlistVbFloorPvc.error = null;
      })
      .addCase(listSafVbFloorBoard.fulfilled, (state, action) => {
        state.getlistVbFloorPvc.loading = false;
        state.getlistVbFloorPvc.success = true;
        state.getlistVbFloorPvc.data = action.payload?.data || [];
        state.getlistVbFloorPvc.pagination = {
          current_page: action.payload?.current_page || 1,
          per_page: action.payload?.per_page || 10,
          total: action.payload?.total || 0,
          total_pages: action.payload?.total_pages || 1,
        };
      })
      .addCase(listSafVbFloorBoard.rejected, (state, action) => {
        state.getlistVbFloorPvc.loading = false;
        state.getlistVbFloorPvc.success = false;
        state.getlistVbFloorPvc.error = action.payload || 'Failed to fetch list';
        state.getlistVbFloorPvc.data = [];
        state.getlistVbFloorPvc.pagination = {
          current_page: 1,
          per_page: 10,
          total: 0,
          total_pages: 1,
        };
      })

      .addCase(fetchVbFloorPvcHistory.pending, (state) => {
        state.VbfloorPvcHistory.loading = true;
        state.VbfloorPvcHistory.error = null;
      })
      .addCase(fetchVbFloorPvcHistory.fulfilled, (state, action) => {
        state.VbfloorPvcHistory.loading = false;
        state.VbfloorPvcHistory.data = action.payload.data;
      })
      .addCase(fetchVbFloorPvcHistory.rejected, (state, action) => {
        state.VbfloorPvcHistory.loading = false;
        state.VbfloorPvcHistory.error = action.payload || 'Failed to fetch history';
        state.VbfloorPvcHistory.data = null;
      })
      .addCase(fetchLuggageRackParams.pending, (state) => {
        state.loading = true;
        state.luggageRackData.loading = true;
        state.luggageRackData.error = null;
      })
      .addCase(fetchLuggageRackParams.fulfilled, (state, action) => {
        state.loading = false;
        state.luggageRackData.loading = false;
        state.luggageRackData.success = true;
        state.luggageRackData.data = action.payload?.data || [];
      })
      .addCase(fetchLuggageRackParams.rejected, (state, action) => {
        state.loading = false;
        state.luggageRackData.loading = false;
        state.luggageRackData.success = false;
        state.luggageRackData.error = action.payload || 'Failed to fetch luggage rack params';
      })
      .addCase(fetchSeatInspectionVBParams.pending, (state) => {
        state.loading = true;
        state.seatParams.loading = true;
        state.seatParams.error = null;
      })
      .addCase(fetchSeatInspectionVBParams.fulfilled, (state, action) => {
        state.loading = false;
        state.seatParams.loading = false;
        state.seatParams.success = true;
        state.seatParams.data = action.payload?.data || [];
      })
      .addCase(fetchSeatInspectionVBParams.rejected, (state, action) => {
        state.loading = false;
        state.seatParams.loading = false;
        state.seatParams.success = false;
        state.seatParams.error = action.payload || 'Failed to fetch luggage rack params';
      })
      .addCase(getViewGlassWool.pending, (state) => {
        state.fetchViewGlassWool.loading = true;
        state.fetchViewGlassWool.error = null;
      })
      .addCase(getViewGlassWool.fulfilled, (state, action) => {
        state.fetchViewGlassWool.loading = false;
        state.fetchViewGlassWool.data = action.payload.data;
      })
      .addCase(getViewGlassWool.rejected, (state, action) => {
        state.fetchViewGlassWool.loading = false;
        state.fetchViewGlassWool.error =
          action.payload || 'Failed to fetch glass door submitted data';
      })
      .addCase(listGlassWool.pending, (state) => {
        state.fetchListGlassWool.loading = true;
        state.fetchListGlassWool.error = null;
      })
      .addCase(listGlassWool.fulfilled, (state, action) => {
        state.fetchListGlassWool.loading = false;
        state.fetchListGlassWool.success = true;
        state.fetchListGlassWool.data = action.payload?.data || [];
        state.fetchListGlassWool.pagination = {
          current_page: action.payload?.current_page || 1,
          per_page: action.payload?.per_page || 10,
          total: action.payload?.total || 0,
          total_pages: action.payload?.total_pages || 1,
        };
      })
      .addCase(listGlassWool.rejected, (state, action) => {
        state.fetchListGlassWool.loading = false;
        state.fetchListGlassWool.success = false;
        state.fetchListGlassWool.error = action.payload || 'Failed to fetch list';
        state.fetchListGlassWool.data = [];
        state.fetchListGlassWool.pagination = {
          current_page: 1,
          per_page: 10,
          total: 0,
          total_pages: 1,
        };
      })

      .addCase(fetchGlassWoolHistory.pending, (state) => {
        state.GlassWoolHistory.loading = true;
        state.GlassWoolHistory.error = null;
      })
      .addCase(fetchGlassWoolHistory.fulfilled, (state, action) => {
        state.GlassWoolHistory.loading = false;
        state.GlassWoolHistory.data = action.payload.data;
      })
      .addCase(fetchGlassWoolHistory.rejected, (state, action) => {
        state.GlassWoolHistory.loading = false;
        state.GlassWoolHistory.error = action.payload || 'Failed to fetch history';
        state.GlassWoolHistory.data = null;
      })
      .addCase(fetchVbAirbrakeParams.pending, (state) => {
        state.vbAirbrakeParams.loading = true;
        state.vbAirbrakeParams.success = false;
        state.vbAirbrakeParams.error = null;
      })
      .addCase(fetchVbAirbrakeParams.fulfilled, (state, action) => {
        state.vbAirbrakeParams.loading = false;
        state.vbAirbrakeParams.success = true;
        state.vbAirbrakeParams.data = action.payload?.data || [];
      })
      .addCase(fetchVbAirbrakeParams.rejected, (state, action) => {
        state.vbAirbrakeParams.loading = false;
        state.vbAirbrakeParams.success = false;
        state.vbAirbrakeParams.error = action.payload || 'Failed to fetch airbrake form params';
      })
      //ac duct
      .addCase(getViewAcDuct.pending, (state) => {
        state.fetchViewAcDuct.loading = true;
        state.fetchViewAcDuct.error = null;
      })
      .addCase(getViewAcDuct.fulfilled, (state, action) => {
        state.fetchViewAcDuct.loading = false;
        state.fetchViewAcDuct.data = action.payload.data;
      })
      .addCase(getViewAcDuct.rejected, (state, action) => {
        state.fetchViewAcDuct.loading = false;
        state.fetchViewAcDuct.error = action.payload || 'Failed to fetch ac duct submitted data';
      })
      .addCase(listAcDuct.pending, (state) => {
        state.fetchListAcDuct.loading = true;
        state.fetchListAcDuct.error = null;
      })
      .addCase(listAcDuct.fulfilled, (state, action) => {
        state.fetchListAcDuct.loading = false;
        state.fetchListAcDuct.success = true;
        state.fetchListAcDuct.data = action.payload?.data || [];
        state.fetchListAcDuct.pagination = {
          current_page: action.payload?.current_page || 1,
          per_page: action.payload?.per_page || 10,
          total: action.payload?.total || 0,
          total_pages: action.payload?.total_pages || 1,
        };
      })
      .addCase(listAcDuct.rejected, (state, action) => {
        state.fetchListAcDuct.loading = false;
        state.fetchListAcDuct.success = false;
        state.fetchListAcDuct.error = action.payload || 'Failed to fetch list';
        state.fetchListAcDuct.data = [];
        state.fetchListAcDuct.pagination = {
          current_page: 1,
          per_page: 10,
          total: 0,
          total_pages: 1,
        };
      })

      .addCase(fetchAcDuctHistory.pending, (state) => {
        state.acDuctHistory.loading = true;
        state.acDuctHistory.error = null;
      })
      .addCase(fetchAcDuctHistory.fulfilled, (state, action) => {
        state.acDuctHistory.loading = false;
        state.acDuctHistory.data = action.payload.data;
      })
      .addCase(fetchAcDuctHistory.rejected, (state, action) => {
        state.acDuctHistory.loading = false;
        state.acDuctHistory.error = action.payload || 'Failed to fetch history';
        state.acDuctHistory.data = null;
      })
      .addCase(addWindow.pending, (state) => {
        state.WindowStoreData.loading = true;
        state.WindowStoreData.error = null;
      })
      .addCase(addWindow.fulfilled, (state, action) => {
        state.WindowStoreData.loading = false;
        state.WindowStoreData.data = action.payload.data;
      })
      .addCase(addWindow.rejected, (state, action) => {
        state.WindowStoreData.loading = false;
        state.WindowStoreData.error = action.payload || 'Failed to fetch floor pvc submitted data';
      })
      .addCase(fetchListWindowData.pending, (state) => {
        state.WindowListData.loading = true;
        state.WindowListData.success = false;
        state.WindowListData.error = null;
      })
      .addCase(fetchListWindowData.fulfilled, (state, action) => {
        state.WindowListData.loading = false;
        state.WindowListData.success = true;
        state.WindowListData.data = action.payload?.data || [];
        state.WindowListData.pagination = {
          current_page: action.payload?.current_page || 1,
          per_page: action.payload?.per_page || 10,
          total: action.payload?.total || 0,
          total_pages: action.payload?.total_pages || 0,
        };
      })
      .addCase(fetchListWindowData.rejected, (state, action) => {
        state.WindowListData.loading = false;
        state.WindowListData.success = false;
        state.WindowListData.error = action.payload || 'Failed to fetch acduct form params';
      })
      .addCase(fetchWindowById.pending, (state) => {
        state.windowDetail.loading = true;
        state.windowDetail.error = null;
      })
      .addCase(fetchWindowById.fulfilled, (state, action) => {
        state.windowDetail.loading = false;
        state.windowDetail.data = action.payload.data;
      })
      .addCase(fetchWindowById.rejected, (state, action) => {
        state.windowDetail.loading = false;
        state.windowDetail.error = action.payload || 'Failed to fetch floor pvc submitted data';
      })
      .addCase(fetchWindowFlowHistory.pending, (state) => {
        state.windowFlowHistory.loading = true;
        state.windowFlowHistory.error = null;
      })
      .addCase(fetchWindowFlowHistory.fulfilled, (state, action) => {
        state.windowFlowHistory.loading = false;
        state.windowFlowHistory.data = action.payload.data;
      })
      .addCase(fetchWindowFlowHistory.rejected, (state, action) => {
        state.windowFlowHistory.loading = false;
        state.windowFlowHistory.error =
          action.payload || 'Failed to fetch floor pvc submitted data';
      })
      //VB Panelling params
      .addCase(fetchPanellingVBParams.pending, (state) => {
        state.vbPanellingParams.loading = true;
        state.vbPanellingParams.success = false;
        state.vbPanellingParams.error = null;
      })
      .addCase(fetchPanellingVBParams.fulfilled, (state, action) => {
        state.vbPanellingParams.loading = false;
        state.vbPanellingParams.success = true;
        state.vbPanellingParams.data = action.payload?.data || [];
      })
      .addCase(fetchPanellingVBParams.rejected, (state, action) => {
        state.vbPanellingParams.loading = false;
        state.vbPanellingParams.success = false;
        state.vbPanellingParams.error = action.payload || 'Failed to fetch panelling form params';
      })
      //VB Lavatory params
      .addCase(fetchLavatoryVBParams.pending, (state) => {
        state.vbLavatoryParams.loading = true;
        state.vbLavatoryParams.success = false;
        state.vbLavatoryParams.error = null;
      })
      .addCase(fetchLavatoryVBParams.fulfilled, (state, action) => {
        state.vbLavatoryParams.loading = false;
        state.vbLavatoryParams.success = true;
        state.vbLavatoryParams.data = action.payload?.data || [];
      })
      .addCase(fetchLavatoryVBParams.rejected, (state, action) => {
        state.vbLavatoryParams.loading = false;
        state.vbLavatoryParams.success = false;
        state.vbLavatoryParams.error = action.payload || 'Failed to fetch lavatory form params';
      })
      .addCase(plugDoorListing.pending, (state) => {
        state.plugDoorListing.loading = true;
        state.plugDoorListing.error = null;
      })
      .addCase(plugDoorListing.fulfilled, (state, action) => {
        state.plugDoorListing.loading = false;
        state.plugDoorListing.success = true;
        state.plugDoorListing.data = Array.isArray(action.payload)
          ? action.payload
          : action.payload?.data || action.payload?.data?.data || [];
      })
      .addCase(plugDoorListing.rejected, (state, action) => {
        state.plugDoorListing.loading = false;
        state.plugDoorListing.error = action.payload || 'Something wents wrong';
      })
      .addCase(addVbPanelling.pending, (state) => {
        state.VbPanelStoreData.loading = true;
        state.VbPanelStoreData.error = null;
      })
      .addCase(addVbPanelling.fulfilled, (state, action) => {
        state.VbPanelStoreData.loading = false;
        state.VbPanelStoreData.data = action.payload.data;
      })
      .addCase(addVbPanelling.rejected, (state, action) => {
        state.VbPanelStoreData.loading = false;
        state.VbPanelStoreData.error = action.payload || 'Failed to store vb paneling data';
      })
      .addCase(fetchListVbPanelData.pending, (state) => {
        state.VbPanleListData.loading = true;
        state.VbPanleListData.success = false;
        state.VbPanleListData.error = null;
      })
      .addCase(fetchListVbPanelData.fulfilled, (state, action) => {
        state.VbPanleListData.loading = false;
        state.VbPanleListData.success = true;
        state.VbPanleListData.data = action.payload?.data || [];
        state.VbPanleListData.pagination = {
          current_page: action.payload?.current_page || 1,
          per_page: action.payload?.per_page || 10,
          total: action.payload?.total || 0,
          total_pages: action.payload?.total_pages || 0,
        };
      })
      .addCase(fetchListVbPanelData.rejected, (state, action) => {
        state.VbPanelListData.loading = false;
        state.VbPanelListData.success = false;
        state.VbPanelListData.error = action.payload || 'Failed to fetch vb panel form data';
      })
      .addCase(fetchVbPanelById.pending, (state) => {
        state.VbPanelDetail.loading = true;
        state.VbPanelDetail.error = null;
      })
      .addCase(fetchVbPanelById.fulfilled, (state, action) => {
        state.VbPanelDetail.loading = false;
        state.VbPanelDetail.data = action.payload.data;
      })
      .addCase(fetchVbPanelById.rejected, (state, action) => {
        state.VbPanelDetail.loading = false;
        state.VbPanelDetail.error = action.payload || 'Failed to fetch vb panel submitted data';
      })
      .addCase(fetchVbPanelFlowHistory.pending, (state) => {
        state.VbPanelFlowHistory.loading = true;
        state.VbPanelFlowHistory.error = null;
      })
      .addCase(fetchVbPanelFlowHistory.fulfilled, (state, action) => {
        state.VbPanelFlowHistory.loading = false;
        state.VbPanelFlowHistory.data = action.payload.data;
      })
      .addCase(fetchVbPanelFlowHistory.rejected, (state, action) => {
        state.VbPanelFlowHistory.loading = false;
        state.VbPanelFlowHistory.error = action.payload || 'Failed to fetch vb panel history data';
      })
      .addCase(addPartitionVB.pending, (state) => {
        state.PartitionVBStoreData.loading = true;
        state.PartitionVBStoreData.error = null;
      })
      .addCase(addPartitionVB.fulfilled, (state, action) => {
        state.PartitionVBStoreData.loading = false;
        state.PartitionVBStoreData.data = action.payload.data;
      })
      .addCase(addPartitionVB.rejected, (state, action) => {
        state.PartitionVBStoreData.loading = false;
        state.PartitionVBStoreData.error = action.payload || 'Failed to save partition VB data';
      })
      .addCase(fetchListPartitionDataVB.pending, (state) => {
        state.PartitionVBListData.loading = true;
        state.PartitionVBListData.success = false;
        state.PartitionVBListData.error = null;
      })
      .addCase(fetchListPartitionDataVB.fulfilled, (state, action) => {
        state.PartitionVBListData.loading = false;
        state.PartitionVBListData.success = true;
        state.PartitionVBListData.data = action.payload?.data || [];
        state.PartitionVBListData.pagination = {
          current_page: action.payload?.current_page || 1,
          per_page: action.payload?.per_page || 10,
          total: action.payload?.total || 0,
          total_pages: action.payload?.total_pages || 0,
        };
      })
      .addCase(fetchListPartitionDataVB.rejected, (state, action) => {
        state.PartitionVBListData.loading = false;
        state.PartitionVBListData.success = false;
        state.PartitionVBListData.error = action.payload || 'Failed to fetch partition VB list';
      })
      .addCase(fetchPartitionByIdVB.pending, (state) => {
        state.partitionVBDetail.loading = true;
        state.partitionVBDetail.error = null;
      })
      .addCase(fetchPartitionByIdVB.fulfilled, (state, action) => {
        state.partitionVBDetail.loading = false;
        state.partitionVBDetail.data = action.payload.data;
      })
      .addCase(fetchPartitionByIdVB.rejected, (state, action) => {
        state.partitionVBDetail.loading = false;
        state.partitionVBDetail.error = action.payload || 'Failed to fetch partition VB details';
      })
      .addCase(fetchPartitionFlowHistoryVB.pending, (state) => {
        state.partitionVBFlowHistory.loading = true;
        state.partitionVBFlowHistory.error = null;
      })
      .addCase(fetchPartitionFlowHistoryVB.fulfilled, (state, action) => {
        state.partitionVBFlowHistory.loading = false;
        state.partitionVBFlowHistory.data = action.payload.data;
      })
      .addCase(fetchPartitionFlowHistoryVB.rejected, (state, action) => {
        state.partitionVBFlowHistory.loading = false;
        state.partitionVBFlowHistory.error =
          action.payload || 'Failed to fetch partition VB flow history';
      })
      .addCase(partitionInspectionActionVB.pending, (state) => {
        state.PartitionVBStoreData.loading = true;
        state.PartitionVBStoreData.error = null;
      })
      .addCase(partitionInspectionActionVB.fulfilled, (state, action) => {
        state.PartitionVBStoreData.loading = false;
        state.PartitionVBStoreData.data = action.payload.data;
      })
      .addCase(partitionInspectionActionVB.rejected, (state, action) => {
        state.PartitionVBStoreData.loading = false;
        state.PartitionVBStoreData.error = action.payload || 'Failed to update partition VB';
      })
      .addCase(addSeatInspectionVB.pending, (state) => {
        state.SeatInspectionVBStoreData.loading = true;
        state.SeatInspectionVBStoreData.error = null;
      })
      .addCase(addSeatInspectionVB.fulfilled, (state, action) => {
        state.SeatInspectionVBStoreData.loading = false;
        state.SeatInspectionVBStoreData.data = action.payload.data;
      })
      .addCase(addSeatInspectionVB.rejected, (state, action) => {
        state.SeatInspectionVBStoreData.loading = false;
        state.SeatInspectionVBStoreData.error =
          action.payload || 'Failed to save seat inspection VB data';
      })
      .addCase(fetchListSeatInspectionVB.pending, (state) => {
        state.SeatInspectionVBListData.loading = true;
        state.SeatInspectionVBListData.success = false;
        state.SeatInspectionVBListData.error = null;
      })
      .addCase(fetchListSeatInspectionVB.fulfilled, (state, action) => {
        state.SeatInspectionVBListData.loading = false;
        state.SeatInspectionVBListData.success = true;
        state.SeatInspectionVBListData.data = action.payload?.data || [];
        state.SeatInspectionVBListData.pagination = {
          current_page: action.payload?.current_page || 1,
          per_page: action.payload?.per_page || 10,
          total: action.payload?.total || 0,
          total_pages: action.payload?.total_pages || 0,
        };
      })
      .addCase(fetchListSeatInspectionVB.rejected, (state, action) => {
        state.SeatInspectionVBListData.loading = false;
        state.SeatInspectionVBListData.success = false;
        state.SeatInspectionVBListData.error =
          action.payload || 'Failed to fetch seat inspection VB list';
      })
      .addCase(fetchSeatInspectionVBById.pending, (state) => {
        state.seatInspectionVBDetail.loading = true;
        state.seatInspectionVBDetail.error = null;
      })
      .addCase(fetchSeatInspectionVBById.fulfilled, (state, action) => {
        state.seatInspectionVBDetail.loading = false;
        state.seatInspectionVBDetail.data = action.payload.data;
      })
      .addCase(fetchSeatInspectionVBById.rejected, (state, action) => {
        state.seatInspectionVBDetail.loading = false;
        state.seatInspectionVBDetail.error =
          action.payload || 'Failed to fetch seat inspection VB details';
      })
      .addCase(fetchSeatInspectionVBFlowHistory.pending, (state) => {
        state.seatInspectionVBFlowHistory.loading = true;
        state.seatInspectionVBFlowHistory.error = null;
      })
      .addCase(fetchSeatInspectionVBFlowHistory.fulfilled, (state, action) => {
        state.seatInspectionVBFlowHistory.loading = false;
        state.seatInspectionVBFlowHistory.data = action.payload.data;
      })
      .addCase(fetchSeatInspectionVBFlowHistory.rejected, (state, action) => {
        state.seatInspectionVBFlowHistory.loading = false;
        state.seatInspectionVBFlowHistory.error = action.payload || 'Failed to fetch flow history';
      })
      .addCase(seatInspectionActionVB.pending, (state) => {
        state.SeatInspectionVBStoreData.loading = true;
        state.SeatInspectionVBStoreData.error = null;
      })
      .addCase(seatInspectionActionVB.fulfilled, (state, action) => {
        state.SeatInspectionVBStoreData.loading = false;
        state.SeatInspectionVBStoreData.data = action.payload.data;
      })
      .addCase(seatInspectionActionVB.rejected, (state, action) => {
        state.SeatInspectionVBStoreData.loading = false;
        state.SeatInspectionVBStoreData.error =
          action.payload || 'Failed to update seat inspection VB';
      })
      .addCase(fetchLuggageRacklist.pending, (state) => {
        state.luggageRackList.loading = true;
        state.luggageRackList.error = null;
      })
      .addCase(fetchLuggageRacklist.fulfilled, (state, action) => {
        state.luggageRackList.loading = false;
        state.luggageRackList.success = true;
        state.luggageRackList.data = Array.isArray(action.payload)
          ? action.payload
          : action.payload?.data || action.payload?.data?.data || [];
      })
      .addCase(fetchLuggageRacklist.rejected, (state, action) => {
        state.luggageRackList.loading = false;
        state.luggageRackList.error = action.payload || 'Something wents wrong';
      })
      .addCase(addVbLavatory.pending, (state) => {
        state.VbLavatoryStoreData.loading = true;
        state.VbLavatoryStoreData.error = null;
      })
      .addCase(addVbLavatory.fulfilled, (state, action) => {
        state.VbLavatoryStoreData.loading = false;
        state.VbLavatoryStoreData.data = action.payload.data;
      })
      .addCase(addVbLavatory.rejected, (state, action) => {
        state.VbLavatoryStoreData.loading = false;
        state.VbLavatoryStoreData.error = action.payload || 'Failed to store vb lavatory data';
      })
      .addCase(fetchListVbLavatoryData.pending, (state) => {
        state.VbLavatoryListData.loading = true;
        state.VbLavatoryListData.success = false;
        state.VbLavatoryListData.error = null;
      })
      .addCase(fetchListVbLavatoryData.fulfilled, (state, action) => {
        state.VbLavatoryListData.loading = false;
        state.VbLavatoryListData.success = true;
        state.VbLavatoryListData.data = action.payload?.data || [];
        state.VbLavatoryListData.pagination = {
          current_page: action.payload?.current_page || 1,
          per_page: action.payload?.per_page || 10,
          total: action.payload?.total || 0,
          total_pages: action.payload?.total_pages || 0,
        };
      })
      .addCase(fetchListVbLavatoryData.rejected, (state, action) => {
        state.VbLavatoryListData.loading = false;
        state.VbLavatoryListData.success = false;
        state.VbLavatoryListData.error = action.payload || 'Failed to fetch vb lavatory form data';
      })
      .addCase(fetchVbLavatoryById.pending, (state) => {
        state.VbLavatoryDetail.loading = true;
        state.VbLavatoryDetail.error = null;
      })
      .addCase(fetchVbLavatoryById.fulfilled, (state, action) => {
        state.VbLavatoryDetail.loading = false;
        state.VbLavatoryDetail.data = action.payload.data;
      })
      .addCase(fetchVbLavatoryById.rejected, (state, action) => {
        state.VbLavatoryDetail.loading = false;
        state.VbLavatoryDetail.error =
          action.payload || 'Failed to fetch vb lavatory submitted data';
      })
      .addCase(fetchVbLavatoryFlowHistory.pending, (state) => {
        state.VbLavatoryFlowHistory.loading = true;
        state.VbLavatoryFlowHistory.error = null;
      })
      .addCase(fetchVbLavatoryFlowHistory.fulfilled, (state, action) => {
        state.VbLavatoryFlowHistory.loading = false;
        state.VbLavatoryFlowHistory.data = action.payload.data;
      })
      .addCase(fetchVbLavatoryFlowHistory.rejected, (state, action) => {
        state.VbLavatoryFlowHistory.loading = false;
        state.VbLavatoryFlowHistory.error =
          action.payload || 'Failed to fetch vb lavatory history data';
      })
      .addCase(addAirBrakeTestVB.pending, (state) => {
        state.AirBrakeTestVBStoreData.loading = true;
        state.AirBrakeTestVBStoreData.error = null;
      })
      .addCase(addAirBrakeTestVB.fulfilled, (state, action) => {
        state.AirBrakeTestVBStoreData.loading = false;
        state.AirBrakeTestVBStoreData.data = action.payload.data;
      })
      .addCase(addAirBrakeTestVB.rejected, (state, action) => {
        state.AirBrakeTestVBStoreData.loading = false;
        state.AirBrakeTestVBStoreData.error =
          action.payload || 'Failed to save air brake test VB data';
      })
      .addCase(fetchListAirBrakeTestVB.pending, (state) => {
        state.AirBrakeTestVBListData.loading = true;
        state.AirBrakeTestVBListData.success = false;
        state.AirBrakeTestVBListData.error = null;
      })
      .addCase(fetchListAirBrakeTestVB.fulfilled, (state, action) => {
        state.AirBrakeTestVBListData.loading = false;
        state.AirBrakeTestVBListData.success = true;
        state.AirBrakeTestVBListData.data = action.payload?.data || [];
        state.AirBrakeTestVBListData.pagination = {
          current_page: action.payload?.current_page || 1,
          per_page: action.payload?.per_page || 10,
          total: action.payload?.total || 0,
          total_pages: action.payload?.total_pages || 0,
        };
      })
      .addCase(fetchListAirBrakeTestVB.rejected, (state, action) => {
        state.AirBrakeTestVBListData.loading = false;
        state.AirBrakeTestVBListData.success = false;
        state.AirBrakeTestVBListData.error =
          action.payload || 'Failed to fetch air brake test VB list';
      })
      .addCase(fetchAirBrakeTestByIdVB.pending, (state) => {
        state.airBrakeTestVBDetail.loading = true;
        state.airBrakeTestVBDetail.error = null;
      })
      .addCase(fetchAirBrakeTestByIdVB.fulfilled, (state, action) => {
        state.airBrakeTestVBDetail.loading = false;
        state.airBrakeTestVBDetail.data = action.payload.data;
      })
      .addCase(fetchAirBrakeTestByIdVB.rejected, (state, action) => {
        state.airBrakeTestVBDetail.loading = false;
        state.airBrakeTestVBDetail.error =
          action.payload || 'Failed to fetch air brake test VB details';
      })
      .addCase(fetchAirBrakeTestFlowHistoryVB.pending, (state) => {
        state.airBrakeTestVBFlowHistory.loading = true;
        state.airBrakeTestVBFlowHistory.error = null;
      })
      .addCase(fetchAirBrakeTestFlowHistoryVB.fulfilled, (state, action) => {
        state.airBrakeTestVBFlowHistory.loading = false;
        state.airBrakeTestVBFlowHistory.data = action.payload.data;
      })
      .addCase(fetchAirBrakeTestFlowHistoryVB.rejected, (state, action) => {
        state.airBrakeTestVBFlowHistory.loading = false;
        state.airBrakeTestVBFlowHistory.error = action.payload || 'Failed to fetch flow history';
      })
      .addCase(airBrakeTestActionVB.pending, (state) => {
        state.AirBrakeTestVBStoreData.loading = true;
        state.AirBrakeTestVBStoreData.error = null;
      })
      .addCase(airBrakeTestActionVB.fulfilled, (state, action) => {
        state.AirBrakeTestVBStoreData.loading = false;
        state.AirBrakeTestVBStoreData.data = action.payload.data;
      })
      .addCase(airBrakeTestActionVB.rejected, (state, action) => {
        state.AirBrakeTestVBStoreData.loading = false;
        state.AirBrakeTestVBStoreData.error =
          action.payload || 'Failed to update air brake test VB';
        state.VbLavatoryFlowHistory.error =
          action.payload || 'Failed to fetch vb lavatory history data';
      })
      // Traction Params Cases
      .addCase(fetchTractionParams.pending, (state) => {
        state.tractionParams.loading = true;
        state.tractionParams.error = null;
        state.tractionParams.success = false;
      })
      .addCase(fetchTractionParams.fulfilled, (state, action) => {
        state.tractionParams.loading = false;
        state.tractionParams.success = true;
        state.tractionParams.data = action.payload?.data || [];
      })
      .addCase(fetchTractionParams.rejected, (state, action) => {
        state.tractionParams.loading = false;
        state.tractionParams.success = false;
        state.tractionParams.error = action.payload || 'Failed to fetch traction parameters';
      })
      .addCase(checkRecordExist.pending, (state) => {
        state.checkRecord.loading = true;
        state.checkRecord.error = null;
        state.checkRecord.exists = false;
      })
      .addCase(checkRecordExist.fulfilled, (state, action) => {
        console.log(831, action.payload?.data?.data?.exists);
        state.checkRecord.loading = false;
        state.checkRecord.data = action.payload.data;
        state.checkRecord.exists = action.payload?.data?.data?.exists || false;
        state.checkRecord.error = null;
      })
      .addCase(checkRecordExist.rejected, (state, action) => {
        state.checkRecord.loading = false;
        state.checkRecord.error = action.payload || 'Failed to check record';
        state.checkRecord.exists = false;
        state.checkRecord.data = null;
      })
      .addCase(fetchBrakeEquipmentSupplier.pending, (state) => {
        state.getSuppliers.loading = true;
        state.getSuppliers.error = null;
      })
      .addCase(fetchBrakeEquipmentSupplier.fulfilled, (state, action) => {
        state.getSuppliers.loading = false;
        state.getSuppliers.data = action.payload.data;
      })
      .addCase(fetchBrakeEquipmentSupplier.rejected, (state, action) => {
        state.getSuppliers.loading = false;
        state.getSuppliers.error = action.payload || 'Failed to supplier data';
      })
      .addCase(fetchInstalledBy.pending, (state) => {
        state.getInstalledBy.loading = true;
        state.getInstalledBy.error = null;
      })
      .addCase(fetchInstalledBy.fulfilled, (state, action) => {
        state.getInstalledBy.loading = false;
        state.getInstalledBy.data = action.payload.data;
      })
      .addCase(fetchInstalledBy.rejected, (state, action) => {
        state.getInstalledBy.loading = false;
        state.getInstalledBy.error = action.payload || 'Failed to installed by data';
      })
      .addCase(fetchPartitionFlowHistoryLHB.pending, (state) => {
        state.fetchPartitionFlowHistoryLHB.loading = true;
        state.fetchPartitionFlowHistoryLHB.error = null;
      })
      .addCase(fetchPartitionFlowHistoryLHB.fulfilled, (state, action) => {
        state.fetchPartitionFlowHistoryLHB.loading = false;
        state.fetchPartitionFlowHistoryLHB.data = action.payload.data;
      })
      .addCase(fetchPartitionFlowHistoryLHB.rejected, (state, action) => {
        state.fetchPartitionFlowHistoryLHB.loading = false;
        state.fetchPartitionFlowHistoryLHB.error = action.payload || 'Failed to fetch partition flow history';
      })
      ;
  },
});

export const { clearMouldingDoorParams, clearPlumbingParams, clearAirBrakeParams } =
  furnishingSlice.actions;
export default furnishingSlice.reducer;
